/*global ajaxurl */
import Glide from '@glidejs/glide';
import axios from 'axios';
import Qs from 'qs';
import ProgressBar from 'progressbar.js';

export default {
  init() {
    // JavaScript to be fired on all pages

    $(window).on('load scroll', function () {
      const top = $(window).scrollTop();
      const header = $('header.banner');
      if (top > 100) {
        header.addClass('bg-white shadow-sm reduced')
      } else if (top < 80) {
        header.removeClass('bg-white shadow-sm reduced')
      } 
    });

    $(window).on('load resize', function() {
      const banner = $('header.banner');
      const header = $('.location-header, .home-header, .header-container');
      if (header.length) {
        $('.global-sidebar .sidebar-fixed-height').height(header.outerHeight());
      }
      if (banner.length) {
        $('.global-sidebar .sidebar-container .menu-icon').height(banner.outerHeight());
      }
      $('.global-sidebar .sidebar-container').addClass('active');
    });

    // Stat circles
    if($('.stats').length > 0){

      let circle = []

      $('.stats').each(function(index){
        let blockId = $(this).data('block')

        let element = `[data-block=${blockId}] .circle`

        let percentage = $(element).data('percentage')
        
        circle[index] = new ProgressBar.Circle(element, {
          strokeWidth: 4,
          easing: 'easeInOut',
          duration: 1400,
          color: '#85529c',
          trailColor: '#C4C3CE',
          trailWidth: 2,
            text: {
              value: '0',
          },
          step: function(state, bar) {
            bar.setText((bar.value() * 100).toFixed(0) + '%');
          },
        })
        
        circle[index].animate(percentage)
      })
    }


     // Nav toggler
    $('.navbar-toggler').click(function() {
      const toggler = $('.navbar-toggler');
      if ($(this).hasClass('collapsed')) {
        toggler.removeClass('collapsed');
        $('.header-menu').addClass('active');
        $('header.banner').addClass('active');
        $('body').addClass('static');
      } else {
        toggler.addClass('collapsed');
        $('.header-menu').removeClass('active');
        $('header.banner').removeClass('active');
        $('body').removeClass('static');
      }
    });
  
       // Provision Slider
      if($('.provision-slides').length > 0) {
      const provision = new Glide(
          '.provision-slides', {
          type: 'carousel',
          perView: 1,
        }).mount()

        provision.on(['run'], function() {
          $('.provision-slides .glide__slide').removeClass('faded', 1000)
        })

        provision.on(['run.after'], function() {
          $('.provision-slides .glide__slide').addClass('faded', 1000)
        })
      }

      // Video Slider
      if($('.video-slider').length > 0) {
        const videoSliderArgs = {
          type: 'carousel',
          perView: 2,
          breakpoints: {
            768: {
              perView: 1,
            },
          },
          gap: 30,
        }

        const videoSliders = document.querySelectorAll('.video-slider');

        Object.values(videoSliders).map(video => {
          new Glide(video, videoSliderArgs).mount();
        })
      }

      // Newsletter Slider
      if($('.newsletter-download-slider').length > 0) {
        const NewsletterSliderArgs = {
          type: 'carousel',
          perView: 4,
          gap: 30,
          startAt: 0,

          breakpoints: {
            992: {
              perView: 2,
            },
            768: {
              perView: 1,
            },
          },
        }

        const newsletterSliders = document.querySelectorAll('.newsletter-download-slider');

        Object.values(newsletterSliders).map(newsletter => {
          new Glide(newsletter, NewsletterSliderArgs).mount();
        });
      }
  
      // Team Slider
      if($('.team-slider').length > 0) {
        const teamSliderArgs = {
          type: 'carousel',
          perView: 4,
          gap: 30,

          breakpoints: {
            768: {
              perView: 2,
            },
          },
        }

        const teamSliders = document.querySelectorAll('.team-slider');

        Object.values(teamSliders).map(team => {
          new Glide(team, teamSliderArgs).mount();
        });

        // Filter team slider
      //   $('[data-filter="team"] a').on('click', function(e) {
      //     e.preventDefault()

      //     $('[data-filter="team"] li').removeClass('active')
      //     $(this).closest('li').addClass('active')

      //     const category = $(this).data('slug')

      //     const data = {
      //       action: 'get_team_members_by_categroy',
      //       category: category,
      //     };

      //   axios.post(ajaxurl, Qs.stringify(data)).then(response => {
      //     /* Need to trim response and check if not empty
      //     An empty response will crash the slider on mount */
      //     const team = response.data.data.team.trim();
      //     if(team !== ''){
      //       teamSlider.destroy()
      //       $('#teamSlider').empty()
      //       $('#teamSlider').append(team)
      //       /* After destroying the slider a new slide instance must be created
      //       As you can't remount the same slider */ 
      //       teamSlider = new Glide(
      //         '.team-slider', 
      //         teamSliderArgs
      //       ).mount()
      //     }
      //   })
      // });
  }

  if($('.testimonial-slider').length > 0) {

    new Glide('.testimonial-slider', {
      type: 'carousel',
      perView: 1,
    }).mount()
  }

  // Event Slider
  if($('.upcoming-event-slider').length > 0) {
    const eventSliderArgs = {
      type: 'carousel',
      perView: 3,
      gap: 15,
      breakpoints: {
        992: {
          perView: 2,
        },
        768: {
          perView: 1,
        },
      },
    }

    let eventSlider = new Glide(
      '.upcoming-event-slider', 
      eventSliderArgs
    ).mount()

    // Filter event slider
    $('[data-filter="event"] a').on('click', function(e) {
      e.preventDefault()

      $('[data-filter="event"] li').removeClass('active')
      $(this).closest('li').addClass('active')

      const category = $(this).data('slug')

      const data = {
        action: 'get_events_by_categroy',
        category: category,
      };

      axios.post(ajaxurl, Qs.stringify(data)).then(response => {

        const event = response.data.data.event;
        const count = response.data.data.count;

        if($('#emptyEvent').length == 0){
          eventSlider.destroy()
        }

        $('#eventSlider').empty()
          if(count > 0){
            $('#eventSlider').append(event)
          // update the per page attribute
          eventSliderArgs.perView = (count < 3 ? count : 3)

            /* After destroying the slider a new slide instance must be created
            As you can't remount the same slider */ 
            eventSlider = new Glide(
              '.upcoming-event-slider', 
              eventSliderArgs
            ).mount()
          } else {
            $('#eventSlider').append('<li id="emptyEvent" class="mx-auto"><h5 class="text-center text-red">There are currently no events.</h5></li>')
          }
        })
      })
    }

        /**
         * Adds left and right margins to meida text so the text half is contained
         */
            function mediaBlockMargins(){
            const left = $('.full-width-image.wp-block-media-text.alignfull.has-media-on-the-right .wp-block-media-text__content')
            const right = $('.full-width-image.wp-block-media-text.alignfull:not(.has-media-on-the-right) .wp-block-media-text__content')

          if($(window).width() >= 1200){
            const containerWidth = $('.container').eq(0).width()
            const windowWidth = $( window ).width();
            const margin = ((windowWidth - containerWidth) / 2) - 15
            left.css('margin-left', margin + 'px')
            right.css('margin-right', margin + 'px')
          }else {
            left.css('margin-left', 0)
            right.css('margin-right', 0)
          }
        }
      
      $(window).resize(function(){
        mediaBlockMargins();
      })

      $(window).load(function(){
        mediaBlockMargins();
      })

      $('#vision-title a').on('click', function(e) {
        e.preventDefault()

        $('#vision-title li').removeClass('active')

        $(this).closest('li').addClass('active')

        const visionTitle = $(this).data('title')

        $('#vision-content li').each(function() {
          const visionContent = $(this).data('content')

          if(visionTitle === visionContent) {
            $(this).removeClass('d-none')
            $(this).addClass('d-block')
          } else {
            $(this).addClass('d-none')
            $(this).removeClass('d-block')
          }
        })
      })

      $('.video-popup a').magnificPopup({
        disableOn: 700,
        type: 'iframe',
        mainClass: 'mfp-fade',
        removalDelay: 160,
        preloader: false,
      });

      $('.image-popup a').magnificPopup({
        type: 'image',
      });

      $('.pride').html(function (i, html){
        return html.replace(/^[^a-zA-Z]*([a-zA-Z])/g, '<span class="text-red">$1</span>')
      });
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
}



// WEBPACK FOOTER //
// ./scripts/routes/common.js